import type { ReactNode } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import citlivy from "../assets/portrait-example-citlivy.webp";
import cubism from "../assets/portrait-example-cubism.webp";
import navenek from "../assets/portrait-example-navenek.webp";
import uvnitr from "../assets/portrait-example-uvnitr.webp";
import watercolor from "../assets/portrait-example-watercolor.webp";
import manifest from "../assets/portrait-examples.json";

// Ukázky obrazu (CR-027 §5): obraz zdarma impastem se všemi čtyřmi vrstvami z vymyšlených profilů
// (generátor `libs/portrait/test/tools/portrait-examples.ts`) v rohu ukázky výsledku a v panelu
// s obrazem na úvodní stránce, tam i týž profil jako placený Portrét kubismem a akvarelem.

const b = (chunks: ReactNode[]) => <strong>{chunks}</strong>;

export const PORTRAIT_EXAMPLES: readonly string[] = [navenek, uvnitr, citlivy];

/** Úvodní stránka, sekce s obrazem: Skica zdarma impastem, pak Portrét kubismem a akvarelem. */
export function HomeExamples() {
  const intl = useIntl();
  const style = (id: string) => intl.formatMessage({ id: `sketch.portrait.style.${id}` });
  const portraits = [
    { src: cubism, style: "cubism" },
    { src: watercolor, style: "watercolor" },
  ];
  return (
    <div className="hero__side">
      <div className="hero__examples" data-testid="portrait-examples">
        <figure>
          <PortraitExample index={0} className="hero__example" />
          <figcaption className="small muted">
            <FormattedMessage id="home.example.sketch" values={{ b }} />
          </figcaption>
        </figure>
        {portraits.map((p) => (
          <figure key={p.style}>
            <img className="hero__example" src={p.src} width={manifest.width / 2} height={manifest.height / 2} alt={intl.formatMessage({ id: "home.example.portraitAlt" }, { style: style(p.style) })} />
            <figcaption className="small muted">
              <FormattedMessage id="home.example.portrait" values={{ style: style(p.style), b }} />
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}

/** Jedna ukázka; `index` vybere obrázek (třeba seed portrétu, ať se u člověka nemění). */
export function PortraitExample({ index, className = "portrait-example" }: { index: number; className?: string }) {
  const intl = useIntl();
  const i = Math.abs(index) % PORTRAIT_EXAMPLES.length;
  return (
    <img
      className={className}
      src={PORTRAIT_EXAMPLES[i]}
      width={manifest.width / 2}
      height={manifest.height / 2}
      alt={intl.formatMessage({ id: "sketch.portrait.example.alt" }, { n: i + 1 })}
      data-testid="portrait-example"
    />
  );
}
